export const translations = {
  VerifyStatus: 'VerifyStatus',
  MarkAsDispensed: 'MarkAsDispensed',
  MarkAsSampled: 'MarkAsSampled',
  UndoDispense: 'UndoDispense',
  UndoSample: 'UndoSample',
  MarkAsDestroyed: 'MarkAsDestroyed',

  Alert: 'Alert',
  ErrorCode: 'ErrorCode',
  WarningFromNmvs: 'WarningFromNmvs',
  Reason: 'Reason',
  ContactAcknowledge: 'ContactAcknowledge',
  Acknowledge: 'Acknowledge',

  SessionTimeout: 'SessionTimeout',
  CleanDateFormat: 'CleanDateFormat',
  ExpiryDateFormat: 'ExpiryDateFormat',
  ShortenedExpiryDateFormat: 'ShortenedExpiryDateFormat',

  ClearCompleted: 'ClearCompleted',
  ManualEntry: 'ManualEntry',

  FileName: 'FileName',
  Download: 'Download',
  ImvoPilotSetupInstructions: 'ImvoPilotSetupInstructions',
  ZebraDevicesSetupInstructions: 'ZebraDevicesSetupInstructions',
  DataLogicGryphonGD4400: 'DataLogicGryphonGD4400',
  DataLogicMagellan9800i: 'DataLogicMagellan9800i',
  DataLogicMagellan3200VSI: 'DataLogicMagellan3200VSI',
  _232KeyConfiguration: '232KeyConfiguration',

  ProductDetails: 'ProductDetails',
  UserDetails: 'UserDetails',
  ProductIdentification: 'ProductIdentification',
  SerialNumber: 'SerialNumber',
  Expiry: 'Expiry',
  LotNumber: 'LotNumber',
  Status: 'Status',

  DeviceInfo: 'DeviceInfo',
  UserProfile: 'UserProfile',
  Users: 'Users',
  Settings: 'Settings',
  Documentation: 'Documentation',
  Logout: 'Logout',

  LoginErrorConnectivity: 'LoginErrorConnectivity',
  InvalidUsernamePassword: 'InvalidUsernamePassword',
  Unauthorized: 'Unauthorized',
  TenantDoesNotExist: 'TenantDoesNotExist',
  Username: 'Username',
  Password: 'Password',
  UsernameRequirement: 'UsernameRequirement',
  RetypePassword: 'RetypePassword',
  Login: 'Login',
  FirstName: 'FirstName',
  LastName: 'LastName',
  Email: 'Email',
  ForgotPassword: 'ForgotPassword',
  ConfirmPasswordReset: 'ConfirmPasswordReset',
  ConfirmPasswordResetMessage: 'ConfirmPasswordResetMessage',
  ResetPassword: 'ResetPassword',
  PasswordResetSuccess: 'PasswordResetSuccess',
  PasswordResetError: 'PasswordResetError',
  PasswordResetOfflineError: 'PasswordResetOfflineError',
  ForgotPasswordContactAdmin: 'ForgotPasswordContactAdmin',
  OtherActions: 'OtherActions',
  UserInfoWarning: 'UserInfoWarning',

  ScannedDateTime: 'ScannedDateTime',
  NmvsResponseTime: 'NmvsResponseTime',
  OptelResponseTime: 'OptelResponseTime',
  TotalResponseTime: 'TotalResponseTime',
  Seconds: 'Seconds',
  NotApplicable: 'NotApplicable',

  Scan: 'Scan',
  ScanOrTypeEpc: 'ScanOrTypeEpc',
  EnterEpcManually: 'EnterEpcManually',
  EpcScannedAuditMessage: 'EpcScannedAuditMessage',
  AlertAcknowledgedAuditMessage: 'AlertAcknowledgedAuditMessage',
  Pending: 'Pending',
  NotFound: 'Not Found',

  DeviceId: 'DeviceId',
  SystemInfo: 'SystemInfo',
  Preferences: 'Preferences',
  Credentials: 'Credentials',
  Country: 'Country',
  Language: 'Language',
  LocationIdentifier: 'LocationIdentifier',
  Certificate: 'Certificate',
  CertificatePassword: 'CertificatePassword',
  Processing: 'Processing',
  Save: 'Save',
  CreateUser: 'CreateUser',
  Submit: 'Submit',
  ClientId: 'ClientId',
  FileNullError: 'FileNullError',
  InvalidFileError: 'InvalidFileError',
  OfflineSettingsMessage: 'OfflineSettingsMessage',
  
  RegisterDevice: 'RegisterDevice',
  UnregisterDevice: 'UnregisterDevice',
  UnregisterDeviceWarning: 'UnregisterDeviceWarning',

  Details: 'Details',
  User: 'User',
  Barcode: 'Barcode',
  Pin: 'Pin',
  RetypePin: 'RetypePin',
  Role: 'Role',
  ChangePIN: 'ChangePIN',
  ChangePassword: 'ChangePassword',
  PasswordMatchError: 'PasswordMatchError',

  NoAvailableOperations: 'NoAvailableOperations',
  Verify: 'Verify',
  TryVerifyAgain: 'TryVerifyAgain',
  Dispense: 'Dispense',
  Sample: 'Sample',
  Destroy: 'Destroy',
  Reintroduce: 'Reintroduce',
  PleaseWait: 'PleaseWait',
  ProductCode: 'ProductCode',
  AvailableOperations: 'AvailableOperations',

  Cancel: 'Cancel',
  AddUser: 'AddUser',
  EditUser: 'EditUser',

  RoleTypeOptelAdmin: 'RoleTypeOptelAdmin',
  RoleTypeOptelSupport: 'RoleTypeOptelSupport',
  RoleTypeTenantAdmin: 'RoleTypeTenantAdmin',
  RoleTypeOperator: 'RoleTypeOperator',
  RoleTypeViewer: 'RoleTypeViewer',
  RoleTypeUnknown: 'RoleTypeUnknown',

  Back: 'Back',
  ActivateUser: 'ActivateUser',
  DeactivateUser: 'DeactivateUser',
  DeleteUser: 'DeleteUser',
  Delete: 'Delete',
  DeleteUserWarning: 'DeleteUserWarning',
  DeleteUserConfirmation: 'DeleteUserConfirmation',
  Yes: 'Yes',
  No: 'No',
  ConfirmDeletion: 'ConfirmDeletion',
  Error: 'Error',
  CommunicationError: 'CommunicationError',
  SaveError: 'SaveError',
  ClickTryAgain: 'ClickTryAgain',
  ClickErrorIconTryAgain: 'ClickErrorIconTryAgain',

  LandingPageSloganPart1: 'LandingPageSloganPart1',
  LandingPageSloganPart2: 'LandingPageSloganPart2',
  FMDAcronym: 'FMDAcronym',
  EuropeanAcronym: 'EuropeanAcronym',
  TermsAndConditions: 'TermsAndConditions',
  AboutOptel: 'AboutOptel',
  AllRightsReserved: 'AllRightsReserved',
  OptelGroup: 'OptelGroup',

  Online: 'Online',
  Offline: 'Offline',
  AwaitingConnection: 'AwaitingConnection',
  SimulateOffline: 'SimulateOffline',
  UndoOfflineWarning: 'UndoOfflineWarning',

  NothingToShow: 'NothingToShow',
  LoadingCerta: 'LoadingCerta',

  OptelTermsOfUseTitle: 'OptelTermsOfUseTitle',
  NmvsTermsOfUseTitle: 'NmvsTermsOfUseTitle',
  NmvsTermsOfUseWarning: 'NmvsTermsOfUseWarning',
  Accept: 'Accept',
  Decline: 'Decline',
  Ignore: 'Ignore',
  Dismiss: 'Dismiss',
  ClickHere: 'ClickHere',

  MustAcceptTermsToLogin: 'MustAcceptTermsToLogin',
  MustBeOnlineToAcceptTermsToLogin: 'MustBeOnlineToAcceptTermsToLogin',

  Austria: 'Austria',
  Belgium: 'Belgium',
  Bulgaria: 'Bulgaria',
  Croatia: 'Croatia',
  Cyprus: 'Cyprus',
  CzechRepublic: 'CzechRepublic',
  Denmark: 'Denmark',
  Estonia: 'Estonia',
  Finland: 'Finland',
  France: 'France',
  Germany: 'Germany',
  Greece: 'Greece',
  Hungary: 'Hungary',
  Iceland: 'Iceland',
  Ireland: 'Ireland',
  Italy: 'Italy',
  Latvia: 'Latvia',
  Liechtenstein: 'Liechtenstein',
  Lithuania: 'Lithuania',
  Luxembourg: 'Luxembourg',
  Malta: 'Malta',
  Netherlands: 'Netherlands',
  Norway: 'Norway',
  Poland: 'Poland',
  Portugal: 'Portugal',
  Romania: 'Romania',
  Slovakia: 'Slovakia',
  Slovenia: 'Slovenia',
  Spain: 'Spain',
  Sweden: 'Sweden',
  Switzerland: 'Switzerland',
  UnitedKingdom: 'UnitedKingdom',

  UnableToParseEpc: 'UnableToParseEpc',
  ProductCodeRequired: 'ProductCodeRequired',
  SerialNumberRequired: 'SerialNumberRequired',
  BatchIdentifierRequired: 'BatchIdentifierRequired',
  ExpiryDateRequired: 'ExpiryDateRequired',
  UnderSizeError: 'UnderSizeError',
  OverSizeError: 'OverSizeError',
  FixedSizeError: 'FixedSizeError',
  NoSerializationData: 'NoSerializationData',
  InvalidCheckDigit: 'InvalidCheckDigit',
  NoProductCodeForGtin: 'NoProductCodeForGtin',
  UrnFormatNotSupported: 'UrnFormatNotSupported',
  InvalidSymbologyIdentifier: 'InvalidSymbologyIdentifier',
  NoSymbologyIdentifier: 'NoSymbologyIdentifier',
  CouldNotFindTypeInfo: 'CouldNotFindTypeInfo',
  NullTypeInfo: 'NullTypeInfo',
  DigitsOnly: 'DigitsOnly',
  CannotSerializeUnknownAi: 'CannotSerializeUnknownAi',
  CheckValueNotChar: 'CheckValueNotChar',
  CheckValueTooBig: 'CheckValueTooBig',
  InvalidFormat: 'InvalidFormat',
  CapsLockDetected: 'CapsLockDetected',
  CapsLockSolution: 'CapsLockSolution',
  ScanAttemptDetected: 'ScanAttemptDetected',
  ScanAttemptSolution: 'ScanAttemptSolution',
  Active: 'Active',
  FullName: 'FullName',
  OnlineAssistance: 'OnlineAssistance',
  UnknownErrorOccurred: 'UnknownErrorOccurred',
  SeparatorMissing: 'SeparatorMissing',
  SeparatorSolution: 'SeparatorSolution',
  ScanCount: 'ScanCount',
  ProductName: 'ProductName',
  ConfirmUnregisterDeviceMessage: 'ConfirmUnregisterDeviceMessage',
  Confirm: 'Confirm'
};


// WEBPACK FOOTER //
// ./src/types/translations.ts